import React, {useMemo} from 'react';
import styled from "styled-components";
import {getCssSizeValue, getFontSize} from "@/utils/utils";
import {BREAKPOINTS} from "@/styles/themeSettings";
import Header from "@/components/Menu/Shared/Header";
import {CONTENT_TYPES} from "@/constants";
import {getLinkData} from "@/components/common/Links/utils";
import Info from "@/components/Menu/Desktop/Info";
import Shortcuts from "@/components/Menu/Desktop/Shortcuts";
import Child from "@/components/Menu/Shared/Child";
import useGlobals from "@/hooks/useGlobals";

const Wrapper = styled.div`
	--row-gap: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
	display: flex;
	position: relative;
	flex-direction: column;
	row-gap: var(--row-gap);
	font-size: ${getFontSize(16)};
    width: fit-content;
    padding-bottom: ${getCssSizeValue(52, BREAKPOINTS.TABLET)};
	
    a{
        text-decoration: none;
		width: fit-content;
    }
	
	
	&.category{
        padding-top: ${getCssSizeValue(40, BREAKPOINTS.TABLET)};
		width: 100%;
        //border: solid 1px red;
		&.indent{
            margin-left: calc(var(--grid-gap) * -1);
			padding-left: var(--grid-gap);
            width: calc(100% + var(--grid-gap));
            border-left: solid 2px ${({theme}) => theme.colors.platinum};
		}
        &.shortcuts{
            height: 100%;
            background-color:${({theme}) => theme.colors.periwinkle};
        }
		&.up{
            padding-top: ${getCssSizeValue(100, BREAKPOINTS.DESKTOP)};
		}
		&.info{
            overflow: visible;
			
			.children{
                row-gap: var(--row-gap);
			}
            scrollbar-width: none;
            &::-webkit-scrollbar {
                display: none;
            }
		}
	}

    > :first-child{
        margin-bottom: calc(var(--row-gap) / 2);
    }

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        --row-gap: ${getCssSizeValue(14, BREAKPOINTS.DESKTOP)};
        padding-bottom: unset;
    }

`


const Children = styled.div`
	display: flex;
	flex-direction: column;
    row-gap: ${getCssSizeValue(16, BREAKPOINTS.TABLET)};
	
	.locale-select{
		margin-top: auto;
		.options{
			//max-height: ${getCssSizeValue(60, BREAKPOINTS.DESKTOP)};
		} 
	}

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        row-gap: var(--row-gap);
    }
`
const Category = ({
	data,
	className= '',
	indent=false,
	children,
	...props
}) => {
	const globals = useGlobals()
	const {
		text,
		isInfo,
		url,
		isShortcuts,
		items,
	} = useMemo(() => {
		const isInfo = data?.isInfoCategory;
		const items = data?.children || []
		const isMenuRecord = data?.__typename === CONTENT_TYPES.MENU
		const isShortcuts = data?.isShortcutsCategory;
		const hasParent = data?.parent;
		const source = isMenuRecord ? data?.universalLink : data
		const { text, url } = getLinkData(source)
		// logTable({
		// 	text,
		// 	url
		// })
		return ({
			text,
			isInfo,
			hasParent,
			isShortcuts,
			url,
			items
		})
	},[data])
	return (
		<Wrapper
			className={`${className} ${indent ? 'indent' : ''} ${isInfo ? 'info' : ''} ${isShortcuts ? 'shortcuts' : ''} col-tablet-2 col-desktop-4 category`}
			{...props}
		>
			{!isInfo && (
				<Header isLink={!isShortcuts} url={url} square={!isShortcuts}>
					{text}
				</Header>
			)}
			{items?.length > 0 && (
				<Children className="children">
					{items.map((child, index) => (
						<Child key={child?.id || index} data={child}/>
					))}
				</Children>
			)}
			{children}
			{isInfo && <Info/>}
			{isShortcuts && <Shortcuts />}
		</Wrapper>
	);
};

export default Category;
